import styled from 'styled-components'
import { Button as ISButton } from '../../Button/Button'

type ISButtonProps = {
  onClick: () => unknown
  text: string
  className?: string
  dataTesting?: string
  backgroundColor?: string
  borderColor?: string
  color?: string
  fontWeight?: string
}

const Button = styled(ISButton)`
  #rle-wizard & {
    ${(props: ISButtonProps) =>
      props.backgroundColor &&
      `
    background-color: ${props.backgroundColor} !important;
  `}
    ${(props: ISButtonProps) =>
      props.borderColor &&
      `
    border-color: ${props.borderColor} !important;
    `}
  ${(props: ISButtonProps) =>
      props.color &&
      `
     color: ${props.color} !important;
  `}
   ${(props: ISButtonProps) =>
      props.fontWeight &&
      `
    font-weight: ${props.fontWeight} !important;
  `}
  }
`

export { Button }
